import React from "react";
import "./AboutUsSection.css";

const AboutUsSection = () => (
  <section className="about-section" id="about">
    <div className="about-container">
      <h2>About Us</h2>

      <div className="about-content">
        <div className="about-intro">
          <p className="about-tagline">
            Premium, eco-friendly car washing experience that protects both your
            vehicle and the environment.
          </p>
        </div>

        <div className="about-services">
          <div className="service">
            <h3>Advanced Technology</h3>
            <p>
              Our steam cleaning technology delivers a deep, effective clean
              using minimal water and zero harsh chemicals.
            </p>
          </div>
          <div className="service">
            <h3>Professional Care</h3>
            <p>
              From exterior detailing to interior cleaning, our team treats
              every vehicle with meticulous attention.
            </p>
          </div>
          <div className="service">
            <h3>Eco-Conscious</h3>
            <p>
              We're committed to sustainable practices, using non-toxic methods
              and conserving water with every service.
            </p>
          </div>
          <div className="service">
            <h3>Green Future</h3>
            <p>
              Our steam technology significantly reduces water consumption
              compared to traditional car washes, helping preserve our precious
              water resources while minimizing environmental impact.
            </p>
          </div>
        </div>

        <div className="about-description">
          <p>
            At <span className="brand">Steam and Drive Car Wash</span>, we
            believe in delivering more than just a clean car. Founded with a
            passion for innovation and sustainability, we specialize in advanced
            steam cleaning technology that uses minimal water while providing a
            deep, thorough clean for every inch of your vehicle.
          </p>
          <p>
            Our professional team ensures that every detail is attended to using
            non-toxic, high-efficiency methods. Steam and Drive provides
            convenient, high-quality service tailored to your needs.
          </p>
          <p>
            We're proud to serve a growing community of customers who value
            efficiency, cleanliness, and eco-responsibility. Experience the
            smarter way to shine.
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default AboutUsSection;
